'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});
exports.sha256 = void 0;
var _sha = require('sha.js');
var sha256 = (exports.sha256 = function sha256(data) {
	return new Uint8Array(new _sha.sha256().update(data).digest());
});
//# sourceMappingURL=hash.js.map
